interface Props { loading: boolean; error: string | null; stale?: boolean; hasData?: boolean; refresh: () => void }
export default function AdminReadState({ loading, error, stale, hasData, refresh }: Props) {
  if (error) return <div className="admin-notice admin-notice--error" role="alert">
    <span>{error}{hasData ? ' Showing the last successful result.' : ''}</span>
    <button className="btn btn-secondary btn-sm" onClick={refresh}>Retry</button>
  </div>;
  if (loading) return <p className="admin-notice" role="status">Loading{hasData ? '… previous results remain visible.' : '…'}</p>;
  if (stale && hasData) return <p className="admin-notice">Showing the last successful result.</p>;
  return null;
}
